// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__h7Epx","col":"styles_col__iPVxB"};